import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import "./navigation.css"
import { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { NavBarMenuItem } from '../../models/types/NavBarMenu';
import narBarMenuData from '../../data/json/common_data/NavBarMenu.json';


const Navigation: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [navData] = useState<NavBarMenuItem[]>(narBarMenuData.menu);
    const [scrolled, setScrolled] = useState(false);
    const navbarToggleRef = useRef<any>(null);



    const [mobileScreen, setMobileScreen] = useState(false);

    // Function to update settings based on window width
    const updateSettings = () => {
        if (window.innerWidth <= 768) {
            setMobileScreen(true);
        } else {
            setMobileScreen(false);
        }
    };
    // UseEffect to set up the event listener
    useEffect(() => {
        updateSettings(); // Set initial settings
        window.addEventListener('resize', updateSettings);
        return () => window.removeEventListener('resize', updateSettings); // Cleanup
    }, []);



    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        if (window.scrollY > 10) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const toggleButton = navbarToggleRef.current;
            const navbar = document.getElementById("basic-navbar-nav");

            if (
                toggleButton &&
                navbar &&
                navbar.classList.contains("show") && // check if navbar is open
                !navbar.contains(event.target as Node) &&
                !toggleButton.contains(event.target as Node)
            ) {
                toggleButton.click(); // close navbar
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    //--------------------------------------------------------------------------
    const isActiveItem = (item: NavBarMenuItem): boolean | undefined => {
        return location.pathname === item.url ||
            (item.children && item.children.some((child) => isActiveItem(child)));
    };

    const getProgressStatus = (progressStatus: number, concatString: string): string | undefined => {
        return ` ${concatString}  dev-progress-status-${progressStatus} `
    };

    // Recursive function to render nav items with level-specific classes
    const renderNavItems = (items: NavBarMenuItem[], level: number = 0) => {
        const sortedItems = [...items].sort((a, b) => a.order - b.order);

        return sortedItems.map((item, index) => (
            <li
                key={item.uniqueId}
                className={`   ${index > 2 ? 'upper-menu' : ''}
                     ${getProgressStatus(item.progressStatus, '')} nav-item nav-menu-level-${level} ${item.children ? 'has-children' : ''}`}
            >

                <Nav.Link
                    className={isActiveItem(item) ? getProgressStatus(item.progressStatus, 'active') : getProgressStatus(item.progressStatus, '')}
                >
                    <div className='nav-link-text' onClick={() => {
                        if (item.url && item.url !== location.pathname) {
                            navigate(item.url)
                            if (navbarToggleRef.current && mobileScreen) {
                                navbarToggleRef.current.click();
                            }
                        }

                    }} >  {item.name} </div>

                    {item.children && !item.childrenHidden ? <img src='/images/Icons/down-arrow.png' alt="arrow" /> : ""}
                </Nav.Link>

                {item.children && !item.childrenHidden && item.children.length > 0 && (
                    <ul className={` ${getProgressStatus(item.progressStatus, '')} dropdown-menu nav-menu-level-${level + 1}`}>
                        {renderNavItems(item.children, level + 1)}
                    </ul>
                )}
            </li>
        ));
    };

    return (
        <>
            <Navbar expand="lg" className={`p-0 main-navbar-container ${scrolled ? "scrolled-navbar-section sticky-top" : ""} `}>
                <Container fluid className='nav-bar-parent-container'>
                    <div className='nav-img-box'>
                        <Navbar.Brand className='nav-img-container' href="/">
                            <img className='nav-img'
                                src="/images/main-logo.png" />
                        </Navbar.Brand>
                    </div>
                    <Container fluid className='nav-links-container'>
                        <Container fluid className="nav-top-wrapper py-2 d-none d-sm-flex justify-content-between align-items-center">
                            <div className='nav-top-wrapper-left-section'>
                                <div className='nav-top-wrapper-left-section-text-container'>
                                    {/* <img src='/images/telephone.png' className='nav-top-wrapper-icon' /> */}
                                    {/* <a href="" target='_blank'> +1-202-555-0175 </a>   */}
                                    </div> 
                                <div className='nav-top-wrapper-left-section-open-time'>
                                    <img src='/images/Icons/clock.png' className='nav-top-wrapper-icon' />
                                    Monday to Friday - 24Hrs </div>
                                <div className='nav-top-wrapper-left-section-text-container'>
                                    <img src='/images/Icons/email.png' className='nav-top-wrapper-icon' />
                                    <a href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@paramayatech.com"
                                        target="_blank" rel="noopener noreferrer">sales@paramayatech.com</a>
                                </div>
                            </div>
                        </Container>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" ref={navbarToggleRef} />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav as="ul" className="me-auto nav-items">
                                {renderNavItems(navData)}
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Container>
            </Navbar>

        </>
    )
}

export default Navigation;
